export const PRODUCTS_PROCESSED = 'PRODUCTS_PROCESSED';

export const LOAD_PRODUCTS = 'LOAD_PRODUCTS';
export const PRODUCTS_LOADED = 'PRODUCTS_LOADED';

export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';
export const FILTER_PRODUCTS = 'FILTER_PRODUCTS';
export const SORT_PRODUCTS = 'SORT_PRODUCTS';
